import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
export const TransactionMessage: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm<any>();
  const navigate = useNavigate();
  // 🔹 State for message + footer
  const [message, setMessage] = useState(
    `Thanks for your purchase with us!!
Purchase Details:
Invoice Amount: 792
Received: 300
Balance: 492
Total Balance: 800`
  );
  const [footer, setFooter] = useState("");

  const handleClose = () => {
    navigate("/");
  };

  return (
    <form>
      {/* Header */}
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Typography fontWeight="bold" variant="h6">
                Transaction Message
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={8}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Select Message Type</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="outlined">
                    Send via vyapar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="outlined">
                    Send via Personal WhatSApp
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Typography>Message Recipient Settings:</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Send SMS to Party"
                    id="sendSmsToParty"
                    control={control}
                    {...register("sendSmsToParty")}
                    rules={{ required: false }}
                    name="sendSmsToParty"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Send Transaction Update SMS"
                    id="transactionUpdateSms"
                    control={control}
                    {...register("transactionUpdateSms")}
                    rules={{ required: false }}
                    name="transactionUpdateSms"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Send SMS Copy to Self"
                    id="sendSMSCopytoSelf"
                    control={control}
                    {...register("sendSMSCopytoSelf")}
                    rules={{ required: false }}
                    name="sendSMSCopytoSelf"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Auto Share Invoices on Vyapar Network"
                    id="autoShareInvoicesonVyaparNetwork"
                    control={control}
                    {...register("autoShareInvoicesonVyaparNetwork")}
                    rules={{ required: false }}
                    name="autoShareInvoicesonVyaparNetwork"
                  />
                </Grid>
              </Grid>
              <Divider sx={{ mt: 2 }} />
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Message content:</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Party Current Balance in SMS"
                    id="partyCurrentBalanceSMS"
                    control={control}
                    {...register("partyCurrentBalanceSMS")}
                    rules={{ required: false }}
                    name="partyCurrentBalanceSMS"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSCheckBoxField
                    label="Web invoice link in SMS"
                    id="WebInvoiceLinkSMS"
                    control={control}
                    {...register("WebInvoiceLinkSMS")}
                    rules={{ required: false }}
                    name="WebInvoiceLinkSMS"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Send Automatic SMS for:</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Sales"
                    id="sales"
                    control={control}
                    {...register("sales")}
                    rules={{ required: false }}
                    name="sales"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Purchase"
                    id="purchase"
                    control={control}
                    {...register("purchase")}
                    rules={{ required: false }}
                    name="purchase"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Sales Return"
                    id="salesReturn"
                    control={control}
                    {...register("salesReturn")}
                    rules={{ required: false }}
                    name="salesReturn"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Purchase Return"
                    id="purchaseReturn"
                    control={control}
                    {...register("purchaseReturn")}
                    rules={{ required: false }}
                    name="purchaseReturn"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Payment In"
                    id="paymentIn"
                    control={control}
                    {...register("paymentIn")}
                    rules={{ required: false }}
                    name="paymentIn"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Payment Out"
                    id="paymentOut"
                    control={control}
                    {...register("paymentOut")}
                    rules={{ required: false }}
                    name="paymentOut"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Sale Order"
                    id="saleOrder"
                    control={control}
                    {...register("saleOrder")}
                    rules={{ required: false }}
                    name="saleOrder"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Purchase Order"
                    id="purchaseOrder"
                    control={control}
                    {...register("purchaseOrder")}
                    rules={{ required: false }}
                    name="purchaseOrder"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Estimate"
                    id="estimate"
                    control={control}
                    {...register("estimate")}
                    rules={{ required: false }}
                    name="estimate"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Proforma Invoice"
                    id="proformaInvoice"
                    control={control}
                    {...register("proformaInvoice")}
                    rules={{ required: false }}
                    name="proformaInvoice"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Delivery Challan"
                    id="deliveryChallan"
                    control={control}
                    {...register("deliveryChallan")}
                    rules={{ required: false }}
                    name="deliveryChallan"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSSCheckBoxField
                    label="Cancelled Invoice"
                    id="cancelledInvoice"
                    control={control}
                    {...register("cancelledInvoice")}
                    rules={{ required: false }}
                    name="cancelledInvoice"
                  />
                </Grid>
              </Grid>
              <Divider sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} md={4}>
          {/* Transaction Type + Edit Message */}
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography fontWeight="bold" gutterBottom>
                Transaction Type:
              </Typography>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="transactionType"
                {...register("transactionType")}
                name="transactionType"
                label="Transaction Type"
                options={config.transactionType.staticOptionData}
              />

              <Grid mt={2}>
                <Typography fontWeight="bold">Edit Message</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)} // 🔹 live update
                />
                <TextField
                  fullWidth
                  placeholder="Footer"
                  value={footer}
                  onChange={(e) => setFooter(e.target.value)} // 🔹 footer update
                  sx={{ mt: 1 }}
                />
              </Grid>
            </CardContent>
          </Card>

          {/* Preview */}
          <Card sx={{ backgroundColor: "#e6ffe6" }}>
            <CardContent>
              <Typography fontWeight="bold" gutterBottom>
                Message Preview
              </Typography>
              <Grid
                sx={{
                  p: 2,
                  backgroundColor: "#d9fdd3",
                  borderRadius: 1,
                  fontFamily: "monospace",
                  whiteSpace: "pre-line",
                }}
              >
                Transaction Image Attached 📎
                {"\n"}
                {message}
                {footer && `\n${footer}`}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
});
